import { SmsConsentSource } from '../../../account-details-card/sms-consent/smsConsentReducer'
import { SmsConsentDialog } from './ConsentDialog'
import { Text } from '@/ui'

export const OptedOut = () => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="md:w-[420px]">
        <Text>
          Get important updates, reminders, and notifications regarding your
          practice&apos;s finances via SMS, such as quarterly payment reminders.
        </Text>
      </div>
      <div className="w-full md:w-auto">
        <SmsConsentDialog source={SmsConsentSource.PRACTICE_PROFILE} />
      </div>
    </div>
  )
}
